import type { IStoreSelectedFacet } from '@generated/graphql'
import React, { useEffect, useRef, useState } from 'react'
import defaultPriceRange from 'src/components/search/Filter/components/PriceRange/data/defaultPriceRange'

import './price-range.scss'
import PriceRangeBox from '../PriceRangeBox'

type Props = {
  min: { selected: number; absolute: number }
  max: { selected: number; absolute: number }
  minPriceSelected?: number
  maxPriceSelected?: number
  setMinPriceSelected: React.Dispatch<React.SetStateAction<number | undefined>>
  setMaxPriceSelected: React.Dispatch<React.SetStateAction<number | undefined>>
  selectedFacets: IStoreSelectedFacet[]
}

function PriceRange({
  min,
  max,
  minPriceSelected,
  maxPriceSelected,
  setMinPriceSelected,
  setMaxPriceSelected,
  selectedFacets,
}: Props) {
  const minAbsoluteFormatted = Math.floor(min?.absolute)
  const maxAbsoluteFormatted = Math.floor(max?.absolute)
  const [minValuePlaceHolder, setMinValuePlaceHolder] =
    useState<number>(minAbsoluteFormatted)

  const [maxValuePlaceHolder, setMaxValuePlaceHolder] =
    useState<number>(maxAbsoluteFormatted)

  const [maxInputValue, setMaxInputValue] = useState<number>()
  const [minInputValue, setMinInputValue] = useState<number>()

  const refMinPrice = useRef<HTMLInputElement>(null)
  const refMaxPrice = useRef<HTMLInputElement>(null)

  function onChangeInputMin(value: number) {
    if (value < min?.absolute || value > max?.absolute) {
      value >= 0
        ? setMinPriceSelected(min?.absolute)
        : setMinPriceSelected(undefined)

      return
    }

    setMinPriceSelected(value)
  }

  function onChangeInputMax(value: number) {
    if (value < min?.absolute || value > max?.absolute) {
      value >= 0
        ? setMaxPriceSelected(max?.absolute)
        : setMaxPriceSelected(undefined)

      return
    }

    setMaxPriceSelected(value)
  }

  const sizeInputNumberDynamic = (
    maxValue: number,
    valuePlaceHolder: number,
    refPriceCurrent?: HTMLInputElement | null
  ) => {
    const calcSize =
      refPriceCurrent && !refPriceCurrent?.value
        ? valuePlaceHolder
        : Number('9'?.repeat(refPriceCurrent?.value?.toString()?.length ?? 1))

    return calcSize > maxValue ? maxValue : calcSize
  }

  const minInputTextColor = minPriceSelected ? 'dark-text' : 'light-text'
  const maxInputTextColor = maxPriceSelected ? 'dark-text' : 'light-text'

  useEffect(() => {
    setMinInputValue(
      sizeInputNumberDynamic(
        maxAbsoluteFormatted,
        minValuePlaceHolder,
        refMinPrice?.current
      )
    )
    setMaxInputValue(
      sizeInputNumberDynamic(
        maxAbsoluteFormatted,
        maxValuePlaceHolder,
        refMaxPrice?.current
      )
    )
  }, [minValuePlaceHolder, maxValuePlaceHolder, maxAbsoluteFormatted])

  return (
    <div className="price-range__container-master">
      <div className="price-range__container">
        <div className="price-range__min-container">
          <label className="price-range__input-label">
            <p className="price-range__input-label-text">Valor mínimo</p>
            <div
              className={`price-range__input-container-${minInputTextColor}`}
            >
              <span>R$</span>
              <input
                ref={refMinPrice}
                className="price-range__min-input"
                type="number"
                placeholder={minValuePlaceHolder?.toString()}
                step="1"
                min={minAbsoluteFormatted}
                max={minInputValue}
                onChange={(e) => {
                  onChangeInputMin(Number(e?.target?.value?.replace('.', '')))
                  setMinInputValue(
                    sizeInputNumberDynamic(
                      maxAbsoluteFormatted,
                      minValuePlaceHolder,
                      refMinPrice?.current
                    )
                  )
                }}
              />
              <span>,00</span>
            </div>
          </label>
        </div>
        <p className="price-range__input-divider">até</p>
        <div className="price-range__max-container">
          <label className="price-range__input-label">
            <p className="price-range__input-label-text">Valor máximo</p>
            <div
              className={`price-range__input-container-${maxInputTextColor}`}
            >
              <span>R$</span>
              <input
                ref={refMaxPrice}
                className="price-range__max-input"
                type="number"
                placeholder={maxValuePlaceHolder?.toString()}
                step="1"
                onChange={(e) => {
                  onChangeInputMax(Number(e?.target?.value?.replace('.', '')))
                  setMaxInputValue(
                    sizeInputNumberDynamic(
                      maxAbsoluteFormatted,
                      maxValuePlaceHolder,
                      refMaxPrice?.current
                    )
                  )
                }}
                min={minAbsoluteFormatted}
                max={maxInputValue}
              />
              <span>,00</span>
            </div>
          </label>
        </div>
      </div>
      <PriceRangeBox
        min={min}
        max={max}
        arrayPriceRange={defaultPriceRange}
        selectedFacets={selectedFacets}
        setMinPriceSelected={setMinPriceSelected}
        setMaxPriceSelected={setMaxPriceSelected}
        setMinValuePlaceHolder={setMinValuePlaceHolder}
        setMaxValuePlaceHolder={setMaxValuePlaceHolder}
      />
    </div>
  )
}

export default PriceRange
